import React from "react"

import { Modal } from "react-bootstrap"
import NumberFormat from "react-number-format"

import { initMap } from "../../common/wdfunction";
import { mapSdk } from "../../../model/base";

import { getCarPrice } from "../../../model/car"

import { commonErr } from "../../common/errors"
import { getAddressName, stypes } from "../../common/common"

import { CustomAddress, ListAddress } from "../selfdrive/locationdelivery"

import { IcAddressType, IcListCar, IcPlane, IcLocationLine, IcUser} from "../../common/svg";

var Buffer = require('buffer/').Buffer

class MapDeliveryWD extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		}

		this.mapDeliveryWD = React.createRef()

		
	}
	componentDidMount() {
		const { carAddress, dAddress } = this.props; 
		if (carAddress.location.lat == dAddress.location.lat && carAddress.location.lng == dAddress.location.lng ) {
			this.initMap([carAddress.location]);	
		} else {
			this.initMap([carAddress.location, dAddress.location]);	
		}
	
	}

	componentDidUpdate(prevProps) {
		const { carAddress } = this.props;
		if (prevProps.dAddress.location !== this.props.dAddress.location) {
			if (carAddress.location.lat == this.props.dAddress.location.lat && carAddress.location.lng == this.props.dAddress.location.lng ) {
				this.initMap([carAddress.location]);	
			} else {
				this.initMap([carAddress.location, this.props.dAddress.location]);
			}
			
		}
	}
	
	initMap = (locAddress) =>{
	
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(true, this.mapDeliveryWD , locAddress, false, 'deli-map', stypes.SD);
			}, 1000)
		}
	
	}


  render() {	
	return <div id="deli-map" ref={this.mapDeliveryWD} style={{ width: '100%', height: '300px', background: 'grey' }}></div>
}
}




export default class LocationDeliveryPickerWD extends React.Component {
    constructor(props) {
        super(props);
        	this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			car: props.car,
			isShowDelivery: props.show,
			isOpenListAddress: false,
			isCustomAddress: false,
			isDelivery: false,
			msgCustom: "",
			carAddress: {
				address: props.car.locationAddrS,
				location: {
					lat: props.car.location.lat,
					lng: props.car.location.lon
				}
			},
			customAddress: {
				address: "",
				location: null
			},
			myAddress: {
				address: "",
				location: null
			},
			dAddress: {
				address: "",
				location: null,
				type: null
			},
			airportAddress: {
				address: "",
				location: null,
				type: null
			}	

        }
 
    	}

		componentDidMount() {
			
			const { car, location, address, deliveryId, listAddress } = this.props;
			
			const data = {
				carId: car.id,
				address: address,
				lat: location.lat,
				lng: location.lng,
				deliveryId: deliveryId,
			};
			this.getCarPrice(data);
			
			if (listAddress) {
				this.props.getListAddress();
			}

			let airportDelivery = false;

			if (deliveryId && car.wdShort.deliveryLocations) { 
				car.wdShort.deliveryLocations.map(delivery => { 
				
					if (delivery.deliveryId == deliveryId && address == delivery.name) {
				
						airportDelivery = true
						this.setState({
							airportAddress: address, 
							location: {
								lat: location.lat, 
								lng: location.lng
							}
						})
					}

				})
			
			}

			if (address !== car.locationAddrS && !airportDelivery) {
				this.setState({
					customAddress: {
						address: address, 
						location: {
							lat: location.lat, 
							lng: location.lng
						}
					}
				})
			}


    		this.setState({
				dAddress: {
					address: address,
					location: {
						lat: location.lat,
						lng: location.lng
					}
				},
				deliveryId: deliveryId
			})

		
		}
		
	componentDidUpdate(prevProps) {
		const { car, listAddress } = this.props;
		const { myAddress, dAddress } = this.state;

		if (prevProps.show !== this.props.show) {
			this.setState({
				isShowDelivery: this.props.show
			})
		}

		if (prevProps.car !== this.props.car) {
			this.setState({
				car,
				carAddress: {
					address: car.locationAddrS,
					location: {
						lat: car.location.lat,
						lng: car.location.lon
					}
				}
			})
		}

		if (listAddress ) {
			if (prevProps.listAddress !== listAddress) { 
				let extAddress = listAddress.filter(addr => { return myAddress.address !== "" && myAddress.location && addr.lat === myAddress.location.lat && addr.lon === myAddress.location.lng }) 
	
				if (myAddress.address !== "" && extAddress.length < 1) {
					this.setState({
						customAddress: {
							address: myAddress.address,
							location: {
								lat: myAddress.location.lat,
								lng: myAddress.location.lng
							}
						},
						dAddress: {
							address: myAddress.address,
							location: {
								lat: myAddress.location.lat,
								lng: myAddress.location.lng
							}
						}
					})
				}

				if (myAddress.address === "" || (myAddress.address !== "" && extAddress.length < 1)) {

					let defaultAddress = listAddress.length > 0 && listAddress.filter(addr => {
						return addr.isDefault === 1
					});

					let address = "";
					let addressLat = 0;
					let addressLng = 0;
		

					if (defaultAddress.length > 0) {
						address = getAddressName(defaultAddress[0]);
						addressLat = defaultAddress[0].lat;
						addressLng = defaultAddress[0].lon;
					
					} else {
						address = getAddressName(listAddress[0]);
						addressLat = listAddress[0].lat;
						addressLng = listAddress[0].lon;
					
					}

					if (dAddress.address === address) {
						this.setState({
							customAddress: {
								address: "",
								location: {
									lat: 0,
									lng: 0 
								}
							}
						})
					}
				
					this.setState({
						myAddress: {
							address,
							location: {
								lat: addressLat,
								lng: addressLng
							}
						}
					})
				}
			} 
		}

		
	}

		getCarPrice = (data) => {
	
			const { carId, address, lat, lng } = data;
			const { startDate, endDate } = this.props;
			let deliveryId = data.deliveryId ? data.deliveryId : undefined;
			const { carAddress } = this.state;
			let latD = lat;
			let lonD = lng;

			if (lat == carAddress.location.lat && lng == carAddress.location.lng ) {
				
				latD = 0; 
				lonD = 0;
			}

		
			getCarPrice(carId, startDate, endDate, latD, lonD, null, deliveryId, stypes.WD, 0, null, null, null, `${lat}-${lng}-${Buffer.from(address).toString('base64')}`, 2).then(carPriceResp => {
					if (carPriceResp.data.error >= commonErr.SUCCESS) {
							this.setState({
									deliveryFee: carPriceResp.data.data.car.wdFull.priceSummary && carPriceResp.data.data.car.wdFull.priceSummary.deliveryFee,
									deliveryDistance: carPriceResp.data.data.car.wdFull.priceSummary &&  carPriceResp.data.data.car.wdFull.priceSummary.deliveryDistance,
							})
					}
			})
					
		}



		isValidAddress = () => {
			const { location } = this.state.dAddress;
			const { deliveryFee } = this.state;
			return deliveryFee > -1 && location && location.lat && location.lat !== 0 && location.lng && location.lng !== 0;
		}

	
	
	
	onUpdateCustomAddress = (address, location) => {
			const { car } = this.state;
			const data = {
				carId: car.id,
				address,
				lat: location.lat,
				lng: location.lng
			};
			
			this.getCarPrice(data)
			
			this.setState({
				customAddress: {
					address,
					location
				},
				dAddress: {
					address,
					location
				},
				deliveryId: undefined
			})
		
	}

	showListAddress = () => {
		this.setState({
			isOpenListAddress: true,
			isShowDelivery: false
		})
	}
	
	closeListAddress = () => {
		this.setState({
			isOpenListAddress: false,
			isShowDelivery: true
		})
	}
	
	onSelectMyAddress = (address) => {
		const { car } = this.state;
		const data = {
			carId: car.id,
			address: address.address,
			lat: address.location.lat,
			lng: address.location.lon,
			deliveryId: undefined
		};
		this.getCarPrice(data); 
	
		this.setState({
			myAddress: {
				address: address.address,
				location: {
					lat: address.location.lat,
					lng: address.location.lon
				}
			},

			dAddress: {
				address: address.address,
				location: {
					lat: address.location.lat,
					lng: address.location.lon
				}
			},
			deliveryId: undefined
		})	
		this.closeListAddress()
	}		

	showCustomAddress = () => {
	
		this.setState({
			isCustomAddress: true,
			isShowDelivery: false
		})
	
	}
	
	closeCustomAddress = () => {
		this.setState({
			isCustomAddress: false,
			isShowDelivery: true
		})	
	}

	
	onSelectPickupAddress = (addressObj, selfPickup) => {
		
			let { address, location } = addressObj;
			const { car, carAddress } = this.state;

			if (addressObj.address == "" || !addressObj.location) {
				this.setState({
					msgCustom: "Vui lòng nhập địa chỉ đưa đón"
				})
				return
			
			} 
			if (selfPickup) {
	
				const data = {
					carId: car.id,
					address: carAddress.address,
					lat: carAddress.location.lat,
					lng: carAddress.location.lng,
					deliveryId: undefined
				};

			
				this.getCarPrice(data);

			} else {

				const data = {
					carId: car.id,
					address: address,
					lat: location.lat,
					lng: location.lng,
					deliveryId: addressObj.deliveryId
				};
				
				this.getCarPrice(data);
			}

			this.setState({
				dAddress: {
					address: address,
					location: {
						lat: location.lat,
						lng: location.lng
					}
				},
				deliveryId: addressObj.deliveryId,
				msgCustom: ""
			})

		
		}

		onUpdate = () => {
			const { isDelivery, dAddress, isShowDelivery, deliveryId} = this.state;
		
			this.props.onUpdate(dAddress.address, dAddress.location, isDelivery, deliveryId)
			this.props.onHide(isShowDelivery);
		}

		onHide = () => {
				const { isShowDelivery } = this.state;
				this.setState({
						err: commonErr.INNIT,
						errMsg: ""
				})
				this.props.onHide(isShowDelivery);
		}

    render() {
			const { listAddress } = this.props;
			const { err, errMsg, deliveryId, isShowDelivery, isCustomAddress, car, isOpenListAddress, dAddress, customAddress, myAddress, carAddress, deliveryFee, deliveryDistance, msgCustom} = this.state;	

			let airport = {};
			if (car.wdShort.deliveryLocations) {
			
				airport = {
					address: car.wdShort.deliveryLocations[0].name, 
					location: {
						lat: car.wdShort.deliveryLocations[0].lat,
						lng: car.wdShort.deliveryLocations[0].lon
					},
					deliveryFee: car.wdShort.deliveryLocations[0].deliveryFee,
					deliveryId: car.wdShort.deliveryLocations[0].deliveryId
				}

			}
	
			return	( <>
					<Modal
					show={isShowDelivery}
					onHide={this.onHide}
					dialogClassName="modal-l modal-dialog modal-delivery-location">
						<Modal.Header closeButton={true} closeLabel={""}>
							<h5>Địa điểm đưa đón</h5>
						</Modal.Header>
						<Modal.Body>
							<div className="delivery-location">
								<div className="map-deli">
									{dAddress.location && <MapDeliveryWD dAddress={dAddress} carAddress={carAddress} /> }
									
									<div className="delivery"> 
										<div className="title"> 
											<p className="main">Đưa đón tận nơi</p>
											<p className="note">Chủ xe sẽ đón và trả khách tận nhà hoặc địa chỉ mà bạn lựa chọn trên ứng dụng Mioto</p>
										</div>
										<div className="content"> 
											<div className="item"> 
												<p>Đưa đón tận nơi trong</p>
												<p className="main">{car.wdShort.deliveryRadius} km</p>
											</div>
											{car.wdShort.deliveryRadiusFree > 0 && (car.wdShort.deliveryRadiusFree !== car.wdShort.delieveryRadius) && <div className="item"> 
												<p>Miễn phí giao nhận trong</p>
												<p className="main">{car.wdShort.deliveryRadiusFree} km</p>
											</div>}
											<div className="item"> 
												<p>Phí đưa đón (2 chiều)</p>
												<p className="main"><NumberFormat value={car.wdShort.deliveryPrice} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ/km"} /></p>
											</div>
										</div>
									</div>
								</div>

								<div className="address-pick">
									<div className={`address-pick__item ${carAddress.address == dAddress.address ? 'active' : ''}`} >
											<div className="custom-radio"> 
												<input type="radio" id="r_carAddressWD" name="addr_pickup_wd" checked={carAddress.address === dAddress.address}  onChange={() => this.onSelectPickupAddress(carAddress, true)} />
												<label htmlFor="r_carAddressWD">Đưa đón tại vị trí xe
													<div className="label-container"> 
													<div className="address">
														<div className="wrap-svg">
															<IcListCar />
														</div>
														<p>{carAddress.address}</p>
													</div>
													<p className="note">Chủ xe sẽ đưa và đón bạn tại vị trí xe (địa chỉ cụ thể sẽ được hiển thị sau khi đặt cọc)</p>
													</div>
												</label>
											</div>
									</div>

									<div className={`address-pick__item ${customAddress.address == dAddress.address ? 'active' : ''}`}> 
										<div className="custom-radio"> 
											<input type="radio" id="r_pickMapWD" name="addr_pickup_wd" checked={customAddress.address === dAddress.address}  onChange={() => this.onSelectPickupAddress(customAddress)}/>
											<label htmlFor="r_pickMapWD" >Chọn từ bản đồ
												<div className="label-container"> 
													<div className="address input" onClick={this.showCustomAddress}>
														<div className="wrap-svg">
															<IcLocationLine />
														</div>
														<p>{customAddress.address !== "" ? customAddress.address : "Chọn địa chỉ giao nhận xe"}</p>	
													</div> 
													{customAddress.address == dAddress.address && <>
														{deliveryFee > 0 ? 
															<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
															: 
															deliveryFee == 0 ? 
															<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
															: 
															<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>
														} 
													</>}
												</div>
											
											</label>
										</div>
									</div>

								{car.wdShort.deliveryLocations && airport && <div className={`address-pick__item ${airport.address == dAddress.address ? 'active' : ''}`} > 
										<div className="custom-radio"> 
										<input type="radio" id="r_airportWD" name="addr_pickup_wd" checked={airport.address === dAddress.address}  onChange={() => this.onSelectPickupAddress(airport)}/>
										<label htmlFor="r_airportWD">Giao xe sân bay
											<div className="label-container"> 
												<div className="address">
													<div className="wrap-svg">
														<IcPlane />
													</div>
													<p>{airport.address}</p>
													
												</div>
												{airport.address == dAddress.address && <>
													{airport.deliveryFee === 0 ? <p className="note text-success">Miễn phí giao nhận xe (2 chiều) cho quãng đường {deliveryDistance} km </p> :
													<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={airport.deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p>}
												</>}
											</div>
										</label>
										</div>
									</div>}

									{myAddress.address && myAddress.address !== '' && <div className={`address-pick__item ${myAddress.address === dAddress.address ? 'active' : ''}`} > 
										<div className="custom-radio" > 
											<input type="radio" id="r_myAddressWD" name="addr_pickup_wd" checked={myAddress.address === dAddress.address} onChange={() => this.onSelectPickupAddress(myAddress)} />
											<label htmlFor="r_myAddressWD">Địa chỉ của tôi
												<div className="label-container"> 
												<div className="address">
													<div className="wrap-svg">
														<IcUser />
													</div>
													<p>{myAddress.address} </p>
												</div>
												{myAddress.address === dAddress.address && <>
													{deliveryFee > 0 ? 
													<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
													: 
													deliveryFee == 0 ? 
													<p className="note text-success">Tổng phí giao nhận xe (2 chiều) là <NumberFormat value={deliveryFee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={' đ'} /> cho quãng đường {deliveryDistance} km</p> 
													: 
													<p className="note text-danger">Địa điểm giao nhận quá xa so với vị trí của xe ({deliveryDistance} km). Bạn vui lòng chọn địa điểm giao nhận gần hơn hoặc có thể chọn thuê xe khác.</p>}
													</>
												} 
												</div>
											</label>
										</div>
										{listAddress && listAddress.length > 1 && <a className="btn btn-link font-12" onClick={() => this.showListAddress()} >Thay đổi</a>}
									
									</div>}

									<a disabled={!dAddress.address || !this.isValidAddress()} onClick={() => this.onUpdate()} className="btn btn-primary btn--m" >Thay đổi</a>
									</div>
							</div>
				</Modal.Body>
				</Modal>
					<CustomAddress
					show={isCustomAddress}
					onHide={this.closeCustomAddress}
					stype={stypes.WD}
					address={customAddress.address}
					location={customAddress.location}
					onUpdate={this.onUpdateCustomAddress}
					deliveryFee={deliveryFee}
					deliveryDistance={deliveryDistance}
					dAddress={dAddress.address}
					msgCustom={msgCustom}
					/>
					{listAddress && listAddress.length > 0 && 
					<ListAddress 
						activeAddress={myAddress} 
						listAddress={listAddress} 
						show={isOpenListAddress} 
						onHide={this.closeListAddress} 
						onSelectMyAddress={this.onSelectMyAddress}/>}
					</> )
    				}
	}


